import { graphql } from '../../graphql';

export const residencesQuery = graphql(`
  query Residences($sort: ResidenceSort!) {
    residences(sort: $sort) {
      id
      name
      city {
        name
      }
      price {
        perSqm
        total {
          minimum
          maximum
        }
        currency
      }
      address
      deadline
      coverUrl
      path
      metroName
      companyName
      updatedAt
    }
  }
`);

export const getCurrentResidenceQuery = graphql(`
  query CurrentResidence($slug: String!) {
    residence(slug: $slug) {
      id
      address
      logoUrl
      showBrandHeader
      apartmentRooms
      itemRooms
      apartments {
        nodes {
          bathroomsCount
          balconiesCount
          repair {
            name
          }
          area
          currency
          description
          id
          mortgagePriceFrom
          priceFrom
          rooms
          photos {
            full
            f660x496
          }
        }
      }
      briefInfo
      brochureUrl
      city {
        id
        name
      }
      companyName
      contactEmail
      coverUrl
      deadline
      description
      hits
      lat
      lng
      metroName
      name
      phonesMasked
      photos {
        full
        f660x496
      }
      price {
        currency
        perSqm
        total {
          maximum
          minimum
        }
      }
      shortAddress
      updatedAt
      website
      youtubeVideoId
      buildingClass {
        name
      }
      buildingsCount
      blocks
      ceilingHeight
      apartmentsCount
      liftsPerBlock
      floorsPerBuildingSplitted
      apartmentsPerFloorSplitted
      decoration {
        name
      }
      windowType {
        name
      }
      technology {
        name
      }
      layout {
        name
      }
      hasBillOfSale
      facilities {
        name
        iconUrl
      }
      constructionProgresses {
        name
        date
        youtubeVideoId
        photos {
          full
        }
        isPromo
      }
      infrastructures {
        distance
        infrastructure {
          name
          iconUrl
        }
      }
      specialOffers {
        name
        description
        offerType
      }
      itemsCount
      locations {
        id
        name
        fullName
      }
      schedule
      hasCollageGallery
      apartmentTypes {
        currency
        priceFrom
        rooms
      }
    }
  }
`);

export const residenceMapMarkersQuery = graphql(`
  query ResidenceMapMarkers {
    residenceMapMarkers {
      address
      companyName
      coverUrl
      deadline
      metroName
      name
      path
      price {
        total {
          maximum
          minimum
        }
        perSqm
        currency
      }
      residenceId
      lat
      lng
    }
  }
`);
